import { InputType } from 'config'

export const defaultInputs = (): Record<string, Record<string, InputType>> => {
  return {
    creditReport: {
      section1: {
        inputType: 'section',
        title: 'Credit Report',
        span: 'full',
      },
      single: {
        title: 'Credit Report Default Cost Single Borrower Report',
        inputType: 'text',
        type: 'thousandSep',
        prefix: '$',
      },
      joint: {
        title: 'Credit Report Default Cost Joint Borrower Report',
        inputType: 'text',
        type: 'thousandSep',
        prefix: '$',
      },
    },
    brokerFee: {
      section1: {
        inputType: 'section',
        title: 'Mortgage Broker Fee (Fee Worksheet)',
        span: 'full',
      },
      defaultPoints: {
        title: 'Company Default Broker Fee Points (%)',
        inputType: 'text',
        type: 'number',
        prefix: '%',
        tooltip:
          'Fallback when the file broker/table funder has no account default. Points win over amount. Still editable on each file.',
      },
      defaultAmount: {
        title: 'Company Default Broker Fee Amount ($)',
        inputType: 'text',
        type: 'thousandSep',
        prefix: '$',
        tooltip: 'Used only when company default points are blank and the account has no default.',
      },
    },
  }
}
